import React, { Component } from "react";
import Box from "../Components/Box";
import { Helmet } from "react-helmet-async";
import { Translation } from "react-i18next";

export default class Home extends Component {
  render() {
    return (
      <>
        {/* SEO metadata */}
        <Translation>
          {(t) => (
            <Helmet>
              <title>
                {t(["seo_home.title"])}
                {/*  AN_DESIGN | Дизайн інтер'єру Україна та Європа, 3D-візуалізація */}
              </title>
              <meta
                name="description"
                content={t([
                  "seo_home.description",
                ])} /* "Професійні послуги з дизайну інтер’єру в Україні та Європі. Повний пакет / Пакет лайт / Пакет креслення пакети пакети з 3D-візуалізацією, плануванням меблів та підбором матеріалів." */
              />
              <meta
                name="keywords"
                content={t([
                  "seo_home.keywords",
                ])} /* "дизайн інтер'єру, дизайн інтер'єру Київ, дизайн інтер'єру Україна, дизайн інтер'єру Європа, проект інтер'єру, 3D візуалізація, ремонт квартир, дизайн проект будинку, інтер'єр квартири, AN_DESIGN" */
              />
              <link
                rel="canonical"
                href="https://an-design-7e5aa.web.app/home"
              />
              {/* Open Graph for social sharing */}
              <meta property="og:title" content={t(["seo_home.title"])} />
              <meta
                property="og:description"
                content={t(["seo_home.description"])}
              />
              <meta property="og:type" content="website" />
              <meta
                property="og:url"
                content="https://an-design-7e5aa.web.app/home"
              />
              <meta
                property="og:image"
                content="https://an-design-7e5aa.web.app/og-image.png"
              />
            </Helmet>
          )}
        </Translation>
        <Box />
      </>
    );
  }
}
